import styled from "styled-components";
import { Select } from "antd";
import { IconButton } from "@mui/material";

export const Overlay = styled.div`
  position: fixed;
  z-index: 1300;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(33, 41, 52, 0.32);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 800px;
  max-width: 95vw;
  box-shadow: 0 8px 32px rgba(33, 41, 52, 0.16);
  padding: 24px;
  position: relative;
  font-family: "Manrope", sans-serif;
  z-index: 1400;
`;

export const CloseButton = styled(IconButton)`
  position: absolute !important;
  right: 24px;
  top: 24px;
  background: none;
  border: none;
  font-size: 20px;
  color: #aeb8c4;
  cursor: pointer;
  border-radius: 4px !important;
  &:hover {
    background-color: #f3f4f7;
  }
`;

export const Header = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0%;
  color: #1B2028;
  margin-bottom: 24px;
`;

export const SubHeader = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #1b2028;
  margin-bottom: 4px;
`;

export const SubLink = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  color: #5a6c87;
  margin-bottom: 18px;
`;

// New styled components for the form sections
export const FormSection = styled.div`
  margin-bottom: 24px;
`;

export const SectionTitle = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #1B2028;
  margin-bottom: 16px;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`;

export const FormField = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const FieldLabel = styled.label`
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #5A6C87;
  margin-bottom: 8px;
`;

export const StyledInput = styled.input`
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #5A6C87;
  padding: 12px 16px;
  border: 1px solid #E3E6E8;
  border-radius: 8px;
  background: #FFFFFF;
  width: 100%;
  box-sizing: border-box;
  
  &::placeholder {
    color: #5A6C87;
  }
  
  &:focus {
    outline: none;
    border-color: #0C53BB;
  }
  
  &:disabled {
    background-color: #F5F5F5;
    color: #9CA3AF;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const StyledSelectField = styled(Select)`
  width: 100%;
  
  .ant-select-selector {
    border-radius: 8px !important;
    height: 44px !important;
    font-family: "Manrope", sans-serif !important;
    font-size: 13px;
    font-weight: 500;
    align-items: center;
    display: flex;
    border: 1px solid #E3E6E8 !important;
    background: #FFFFFF !important;
    padding-right: 30px !important;
  }

  .ant-select-selection-placeholder {
    font-size: 13px;
    color: #5A6C87;
  }

  .ant-select-selection-item {
    font-size: 13px;
    color: #5A6C87;
  }

  .ant-select-arrow {
    position: absolute !important;
    top: 69% !important;
    right: 12px !important;
    transform: translateY(-50%) !important;
    transition: transform 0.3s ease;
    margin-top: 0 !important;
    height: 12px !important;
    width: 12px !important;
  }

  .ant-select-arrow svg {
    width: 12px !important;
    height: 12px !important;
  }

  &:hover .ant-select-selector {
    border: 1px solid #E3E6E8 !important;
    box-shadow: none !important;
  }

  &.ant-select-focused .ant-select-selector {
    border: 1px solid #0C53BB !important;
    box-shadow: none !important;
  }

  &.ant-select-open .ant-select-arrow {
    transform: translateY(-50%) rotate(180deg) !important;
  }

  // Global dropdown styling with higher specificity
  && .ant-select-dropdown {
    font-family: "Manrope", sans-serif !important;
    z-index: 9999 !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  }

  && .ant-select-dropdown .ant-select-item {
    padding: 8px 12px !important;
    font-size: 13px !important;
    color: #5A6C87 !important;
  }

  && .ant-select-dropdown .ant-select-item-option-selected {
    background-color: #f0f7ff !important;
    color: #0c53bb !important;
  }

  && .ant-select-dropdown .ant-select-item-option-active {
    background-color: #f5f5f5 !important;
  }
`;

export const FileSelectedSection = styled.div`
  margin-bottom: 24px;
`;

export const FileSelectedBox = styled.div`
  width: 702px;
  height: 67px;
  border-radius: 8px;
  border: 1px dashed #6894D6;
  background: #F1F6FE;
  padding: 24px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  justify-content: flex-start;
`;

export const FileIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const FileName = styled.span`
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  vertical-align: middle;
  color: #1B2028;
`;

export const PreviewIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const StyledTemplateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
  gap: 8px;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  position: relative;

  .ant-select-selector {
    border-radius: 8px !important;
    height: 44px !important;
    font-family: "Manrope", sans-serif !important;
    font-size: 16px;
    align-items: center;
    display: flex;
  }

  .ant-select-item-option-content {
    font-size: 13px;
  }

  &:hover .ant-select-selector {
    border: 1px solid #d9d9d9 !important;
    box-shadow: none !important;
  }

  // keep same border on focus
  &.ant-select-focused .ant-select-selector {
    border: 1px solid #d9d9d9 !important;
    box-shadow: none !important;
  }

  // keep same border on error
  &.ant-select-status-error .ant-select-selector {
    border: 1px solid #d9d9d9 !important;
    box-shadow: none !important;
  }
  .ant-select-arrow {
    transition: transform 0.5s ease;
    top: 22px;
  }

  // Placeholder text
  .ant-select-selection-placeholder {
    font-size: 13px;
    color: #5a6c87; // adjust to your placeholder color
  }

  .ant-select-selection-item {
    font-size: 13px;
    color: #364151;
  }

  .ant-select-dropdown {
    font-family: "Manrope", sans-serif;
    z-index: 1500 !important;
  }

  .ant-select-dropdown .ant-select-item {
    padding: 8px 12px;
    font-size: 14px;
  }

  .ant-select-dropdown .ant-select-item-option-selected {
    background-color: #f0f7ff;
    color: #0c53bb;
  }

  .ant-select-dropdown .ant-select-item-option-active {
    background-color: #f5f5f5;
  }
`;

export const DividerRow = styled.div`
  display: flex;
  align-items: center;
  margin: 16px 0 24px 0;
`;

export const Divider = styled.hr`
  flex: 1;
  height: 1px;
  background: #e3e6e8;
  border: none;
`;

export const Or = styled.span`
  margin: 0 16px;
  color: #aeb8c4;
  font-weight: 500;
  font-size: 16px;
`;

export const UploadLabel = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #1b2028;
  margin-bottom: 12px;
`;

export const DropZone = styled.div`
  border: 1px dashed #dde2e9;
  border-radius: 8px;
  min-height: 170px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 32px;
  padding: 24px;
  gap: 8px;
  transition: border 0.2s, background 0.2s;
  border-color: ${({ isDragActive }) => (isDragActive ? "#0C53BB" : "#DDE2E9")};
  background-color: ${({ isDragActive }) =>
    isDragActive ? "#E3F2FD" : "#FFF"};
`;

export const UploadIconWrapper = styled.div`
  margin-bottom: 8px;
  img {
    width: 48px;
    height: 48px;
    display: block;
  }
`;

export const UploadText = styled.div`
  color: #5a6c87;
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  margin-bottom: 8px;
  max-width: 220px;
`;

export const UploadLink = styled.span`
  color: #0C53BB;
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const Btn = styled.button`
  font-family: "Manrope", sans-serif;
  font-weight: 600; // <-- Figma: 600
  font-size: 13px; // <-- Figma: 13px
  line-height: 100%; // <-- Figma: 100%
  letter-spacing: 0;
  border-radius: 6px;
  border: 1px solid #dde2e9;
  background: #f3f4f7;
  color: #1b2028; // <-- Figma: #1B2028
  padding: 10px 12px;
  min-width: 68px;
  height: 32px;
  cursor: pointer;
  transition: background 0.2s;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NextButton = styled(Btn)`
  background: #0c53bb;
  color: #fff;
  border: none;
  min-width: 54px;
  width: 54px;
  height: 32px;
  border-radius: 6px;
  padding: 10px 12px;
  gap: 10px;
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  margin-left: 0;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background: #084080;
  }
`;

export const UploadedFile = styled.div`
  width: 100%;
  min-height: 67px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px dashed #0c53bb;
  background: #f1f6fe;
  padding: 24px 16px;
  box-sizing: border-box;
  margin-bottom: 32px;
`;

export const UploadedFileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const UploadedFileName = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  color: #1b2028;
  background: transparent;
  text-align: center;
  vertical-align: middle;
`;

export const UploadedFileClose = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-left: 16px;
  cursor: pointer;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  &:hover {
    background: #e3e6e8;
  }
  img {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: block;
  }
`;

export const PreviewButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  position: absolute;
  top: 80px;
  right: 32px;
  background: none;
  border: none;
  padding: 0;
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 100%;
  color: #0c53bb;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    text-decoration: underline;
  }
  img {
    width: 16px;
    height: 16px;
    display: block;
  }
`;

export const ErrorInput = styled(StyledInput)`
  border: 1.5px solid #e57373 !important;
  background: #fdf3f3 !important;
  color: #364151;
`;

export const ErrorSelect = styled(StyledSelectField)`
  .ant-select-selector {
    border: 1.5px solid #e57373 !important;
    background: #fdf3f3 !important;
    color: #364151;
  }
`;

export const ErrorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  color: #e57373;
  font-size: 16px;
  font-family: "Manrope", sans-serif;
`;

export const ErrorRowSelect = styled(ErrorRow)`
  margin-top: 8px;
  margin-bottom: 4px;
`;

export const ErrorIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 4px;
`;

export const ErrorText = styled.span`
  color: #C63939;
  font-family: "Switzer Variable", sans-serif;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  line-height: 118%;
  letter-spacing: 0%;
  vertical-align: middle;
`;
